// extracted by mini-css-extract-plugin
export default {"text":"SlackText-module__text--8l2im","animatedBackground":"SlackText-module__animatedBackground--I-8tq"};